import React from "react";

// Kiolvassuk a configból, vagy 200-at használunk defaultként
const VOTES_PER_SHOT = window.RUNTIME_CONFIG?.VOTES_PER_SHOT || 200;

interface TileProps {
  index: number;
  votes: number;
  selected: boolean;
  disabled: boolean;
  onSelect: (index: number) => void;
}

const Tile: React.FC<TileProps> = ({ index, votes, selected, disabled, onSelect }) => {
  // A fix 200 helyett a környezeti változót használjuk
  const readyShots = Math.floor(votes / VOTES_PER_SHOT);
  const progress = votes % VOTES_PER_SHOT;
  const percentage = (progress / VOTES_PER_SHOT) * 100;

  return (
    <div className="flex flex-col items-center w-full">
      <button
        disabled={disabled}
        onClick={() => onSelect(index)}
        className={`w-full aspect-square rounded-md border-2 flex flex-col items-center justify-center transition-colors
          disabled:cursor-not-allowed disabled:opacity-50
          ${selected
            ? "border-amber-400 bg-amber-500 text-slate-900"
            : "border-slate-600 bg-slate-700 text-white hover:bg-slate-600"}`}
      >
        <span className="font-bold text-xs leading-none">{index + 1}</span>
        <span className={`text-micro mt-0.5 ${selected ? 'opacity-80 font-bold' : 'opacity-70'}`}>
          {votes}
        </span>
      </button>
      
      <div className="w-3/4 bg-slate-800 rounded-full h-1 border border-slate-700 mt-1.5 relative overflow-hidden">
        <div className="bg-amber-500 h-1 animate-bar" style={{ width: `${percentage}%` }}></div>
      </div>
      
      <svg viewBox="0 0 100 85" className="w-full max-w-[22px] h-auto overflow-visible mt-1 opacity-80">
        <rect x="35" y="10" width="30" height="60" fill="#475569" stroke="#94a3b8" strokeWidth="4" rx="2" />
        <rect x="30" y="55" width="40" height="15" fill="#334155" stroke="#94a3b8" strokeWidth="4" rx="4" />
        <path d="M 15 0 L 85 0 A 35 35 0 0 1 15 0 Z" fill="#64748b" stroke="#94a3b8" strokeWidth="4" />
      </svg>
      
      <div className="text-orange-500 font-bold text-sm mt-1 leading-none">{readyShots}</div>
    </div>
  );
};

export default Tile;